import { z } from 'zod';

export type IngressProtectionType = 'IP' | 'NEMA';

const ingressProtection = {
    IP: [
        'IP00',
        'IP01',
        'IP02',
        'IP03',
        'IP04',
        'IP05',
        'IP06',
        'IP07',
        'IP08',
        'IP09',
        'IP10',
        'IP11',
        'IP12',
        'IP13',
        'IP14',
        'IP15',
        'IP16',
        'IP17',
        'IP18',
        'IP19',
        'IP20',
        'IP21',
        'IP22',
        'IP23',
        'IP24',
        'IP25',
        'IP26',
        'IP27',
        'IP28',
        'IP29',
        'IP30',
        'IP31',
        'IP32',
        'IP33',
        'IP34',
        'IP35',
        'IP36',
        'IP37',
        'IP38',
        'IP39',
        'IP40',
        'IP41',
        'IP42',
        'IP43',
        'IP44',
        'IP45',
        'IP46',
        'IP47',
        'IP48',
        'IP49',
        'IP50',
        'IP51',
        'IP52',
        'IP53',
        'IP54',
        'IP55',
        'IP56',
        'IP57',
        'IP58',
        'IP59',
        'IP60',
        'IP61',
        'IP62',
        'IP63',
        'IP64',
        'IP65',
        'IP66',
        'IP67',
        'IP68',
        'IP69',
    ],
    NEMA: ['1', '2', '3', '3X', '3S', '3SX', '3R', '3RX', '4', '4X', '5', '6', '6P', '12', '12K', '13'],
} as const;

export type IngressProtection_IP = (typeof ingressProtection)['IP'][number];
export type IngressProtection_NEMA = (typeof ingressProtection)['NEMA'][number];

export const IngressProtection = {
    IP: {
        validator: z.enum(ingressProtection.IP).optional(),
        options: ingressProtection.IP,
    },
    NEMA: {
        validator: z.enum(ingressProtection.NEMA).optional(),
        options: ingressProtection.NEMA,
    },
};
